export enum KEYS_WEB_STORAGE {
	'DATA_USER' = 'data_user'
	
}

export enum CRUD_METHOD {
	'SAVE' = 1,
	'UPDATE' = 2
}

export enum STATUS_CRUD {
	'INACTIVO' = 0,
	'ACTIVO' = 1
}